/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;



//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/~/lodash/_getHolder.js
// module id = 317
// module chunks = 0